const TOAST_CONTENTS = {
  nftStakeSuccess: {
    heading: 'Success',
    text: 'Your NFTs were staked',
  },
}

export default TOAST_CONTENTS
